import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RecurrencyRemoveRange } from 'app/interfaces/availability.interface';

@Component({
	selector: 'confirm-action-busy-slot',
	templateUrl: './confirm-action-busy-slot.component.html',
})
export class ConfirmActionBusySlotComponent implements OnInit {
	@Output() onChangeOption = new EventEmitter();
	@Output() onConfirmOption = new EventEmitter();
	@Input() open = false;
	selectedOption: RecurrencyRemoveRange;
	constructor() {}

	ngOnInit(): void {
		this.selectedOption = RecurrencyRemoveRange.ONLY;
	}

	setOption(value: string) {
		this.selectedOption = value as RecurrencyRemoveRange;
		this.onChangeOption.emit(value);
	}

	confirm() {
		this.onConfirmOption.emit(this.selectedOption);
	}

	close() {
		this.open = false;
	}
}
